import type { LucideIcon } from 'lucide-react';
import {
  Archive,
  CircleDollarSign,
  CircleHelp,
  Fence,
  HeartPulse,
  Home,
  Hospital,
  Trees,
} from 'lucide-react';

/** Tipos de lote suportados pela API (enum `lots.lot_type`). */
export const LOT_TYPES = [
  {
    value: 'pasture',
    label: 'Pasto / piquete',
    shortLabel: 'Pasto',
    icon: Trees,
  },
  {
    value: 'pen',
    label: 'Baia',
    shortLabel: 'Baia',
    icon: Home,
  },
  {
    value: 'corral',
    label: 'Curral',
    shortLabel: 'Curral',
    icon: Fence,
  },
  {
    value: 'maternity',
    label: 'Maternidade',
    shortLabel: 'Maternidade',
    icon: HeartPulse,
  },
  {
    value: 'infirmary',
    label: 'Enfermaria',
    shortLabel: 'Enfermaria',
    icon: Hospital,
  },
  {
    value: 'archive',
    label: 'Arquivo',
    shortLabel: 'Arquivo',
    icon: Archive,
  },
  {
    value: 'sale',
    label: 'Venda / embarque',
    shortLabel: 'Venda',
    icon: CircleDollarSign,
  },
  {
    value: 'other',
    label: 'Outro (cocho, quarentena…)',
    shortLabel: 'Outro',
    icon: CircleHelp,
  },
] as const;

export type LotTypeValue = (typeof LOT_TYPES)[number]['value'];

export function lotTypeLabel(type: string): string {
  return LOT_TYPES.find((t) => t.value === type)?.label ?? type;
}

export function lotTypeIcon(type: string): LucideIcon {
  return LOT_TYPES.find((t) => t.value === type)?.icon ?? CircleHelp;
}
